import { render, staticRenderFns } from "./baseFoot.vue?vue&type=template&id=1491ea8e"
import script from "./baseFoot.vue?vue&type=script&lang=js"
export * from "./baseFoot.vue?vue&type=script&lang=js"
import style0 from "./baseFoot.vue?vue&type=style&index=0&id=1491ea8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports